import { render, staticRenderFns } from "./FondsanteileBox.vue?vue&type=template&id=aeb0beec&scoped=true&"
import script from "./FondsanteileBox.vue?vue&type=script&lang=ts&"
export * from "./FondsanteileBox.vue?vue&type=script&lang=ts&"
import style0 from "./FondsanteileBox.vue?vue&type=style&index=0&id=aeb0beec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb0beec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VDivider,VRow})
